import { Accordion, Paper, Stack, Title } from '@mantine/core'
import type { FAQItem } from '../types'
import { usePostHog } from '@/lib/posthog'
import { trackFaqExpanded } from '@/features/diy/utils/analytics'

interface ProjectGuideFAQProps {
  items: Array<FAQItem>
  projectSlug: string
}

export function ProjectGuideFAQ({ items, projectSlug }: ProjectGuideFAQProps) {
  const posthog = usePostHog()

  if (items.length === 0) {
    return null
  }

  return (
    <Paper id="faq" data-toc-section p="lg" withBorder radius="md">
      <Stack gap="md">
        <Title order={2} size="h3">
          Common Questions
        </Title>

        <Accordion
          variant="separated"
          radius="md"
          onChange={(value) => {
            if (value === null) return
            const match = /^faq-(\d+)$/.exec(value)
            if (!match) return
            const index = Number.parseInt(match[1], 10)
            const item = items.at(index)
            if (!item) return
            trackFaqExpanded(posthog, {
              projectSlug,
              questionIndex: index,
              questionText: item.question,
            })
          }}
        >
          {items.map((item, index) => (
            <Accordion.Item key={index} value={`faq-${index}`}>
              <Accordion.Control>
                {item.question}
              </Accordion.Control>
              <Accordion.Panel>
                {item.answer}
              </Accordion.Panel>
            </Accordion.Item>
          ))}
        </Accordion>
      </Stack>
    </Paper>
  )
}
